import React, { use } from 'react';
import ConfirmationPopupProviderContext from 'shared/components/confirmation-pop-up/providers/contexts/confirmation-popup-provider-context';
import PopUp from 'shared/components/pop-up/pop-up';

const ConfirmationPopUp = (): React.JSX.Element => {
  const { isPopupVisible, title, text, confirmText, cancelText, confirm } = use(ConfirmationPopupProviderContext);

  return (
    <PopUp
      isOpen={isPopupVisible}
      title={title}
      body={text}
      primaryButtonText={confirmText}
      secondaryButtonText={cancelText}
      handleOnClose={() => confirm(false)}
      secondaryButtonAction={() => confirm(false)}
      primaryButtonAction={() => confirm(true)}
    />
  );
};

export default ConfirmationPopUp;
